exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stop-all_stop-all_3zymO {\n    position: fixed;\n    right: 519px;\n    bottom: 160px;\n    width: 2.2rem;\n    height: 2.2rem;\n    padding: 0.375rem;\n    border-radius: 0.25rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n    -webkit-transition: 0.2s ease-out;\n    transition: 0.2s ease-out;\n    border: 2px solid #d6d3d3;\n    border-radius: 50%;\n    background-color: #fff;\n    display:none;\n}\n\n\n.stop-all_stop-all_3zymO:hover {\n    /* transform: scale(1.2); */\n}\n\n\n.stop-all_stop-all_3zymO.stop-all_is-active_3r1ox {\n    opacity: 1;\n}\n", ""]);

// exports
exports.locals = {
	"stop-all": "stop-all_stop-all_3zymO",
	"stopAll": "stop-all_stop-all_3zymO",
	"is-active": "stop-all_is-active_3r1ox",
	"isActive": "stop-all_is-active_3r1ox"
};